export default __webpack_public_path__ + "static/media/illustration_contribution.f71971f9.svg";